<h1 mat-dialog-title>Delete debt</h1>
<mat-dialog-content>
  Confirm delete of debt.
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>No</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</mat-dialog-actions>